export default {
  INCOME: 'income',
  STATUS: 'status',
  PRIORITY: 'priority',
  AGENT: 'agent',
  TAG: 'tag',
  MAJOR_TASK: 'majorTask',
  MIDDLE_TASK: 'middleTask',
  MINOR_TASK: 'minorTask',
  TASK_TYPE_ID: 'taskTypeId',
  TASK_AUTO: 'taskAuto',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PAGE_SIZE: 'pageSize',
  CUSTOMER_SEARCH: 'customerSearch',
  TICKET_SEARCH: 'ticketSearch',
  ORDER: 'order',
  ASCENDING: 'ascending',
  SERVICE_ID: 'serviceId'
}



// WEBPACK FOOTER //
// ./src/components/menus/ticket/enums/ticketListOptionType.js